import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table, Tbody, Td, Th, Thead, Tr, Text, Box } from '@chakra-ui/react';
import CInput from './CInput';
import ColorPicker from './ColorPicker';

const TableRow = ({ range, color_code, onRangeUpdate, errorMessage }) => {
    return (
        <>
            <Tr p="0px">
                <Td pb={0}>
                    <CInput
                        type="number"
                        value={range.from}
                        onChange={(value) => onRangeUpdate('from', value)}
                        maxDecimals={0}
                        borderColor={errorMessage ? 'red.500' : 'gray.200'}
                        mb={0}
                    />
                </Td>
                <Td pb={0}>
                    <CInput
                        type="number"
                        value={range.to}
                        onChange={(value) => onRangeUpdate('to', value)}
                        maxDecimals={0}
                        borderColor={errorMessage ? 'red.500' : 'gray.200'}
                        mb={0}
                    />
                </Td>
                <Td pb={0}>
                    <Box width={'35px'} height={'35px'} bgColor={color_code} border='1px' cursor='not-allowed'></Box>
                </Td>
            </Tr>
            {errorMessage && (
                <Tr>
                    <Td colSpan="3" pt={0} pb={0}>
                        <Text color="red.500" fontSize="sm">
                            {errorMessage}
                        </Text>
                    </Td>
                </Tr>
            )}
        </>
    );
};

TableRow.propTypes = {
    range: PropTypes.shape({
        from: PropTypes.number.isRequired,
        to: PropTypes.number.isRequired,
    }).isRequired,
    color_code: PropTypes.string.isRequired,
    onRangeUpdate: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
};

const RangeColorTable = ({ rows, setRows }) => {
    const safeRows = Array.isArray(rows) ? rows : [];

    const [errors, setErrors] = useState({});

    const updateRangeValue = (index, key, value) => {
        const updatedRows = safeRows.map((row, i) =>
            i === index ? { ...row, range: { ...row.range, [key]: value } } : row
        );
        setRows(updatedRows);

        // Validate the range and set error if "from" is greater than "to"
        const updatedErrors = { ...errors };
        if (key === 'from' || key === 'to') {
            const fromValue = updatedRows[index].range.from;
            const toValue = updatedRows[index].range.to;
            if (fromValue === "" || toValue === "" || fromValue === null || toValue === null || (Number(fromValue) > Number(toValue))) {
                updatedErrors[index] = 'Please provide a valid range.';
            } else {
                delete updatedErrors[index]; // Remove error if valid
            }
        }

        setErrors(updatedErrors);
    };

    return (
        <Table variant="simple">
            <Thead>
                <Tr>
                    <Th colSpan="3" textAlign='center' width='100%'>
                        <Text fontWeight={"900"} color="black">Range</Text>
                    </Th>
                </Tr>
                <Tr>
                    <Th>From</Th>
                    <Th>To</Th>
                    <Th>Color Code</Th>
                </Tr>
            </Thead>
            <Tbody>
                {safeRows.map((row, index) => (
                    <TableRow
                        key={index}
                        range={row.range}
                        color_code={row.color_code}
                        onRangeUpdate={(key, value) => updateRangeValue(index, key, value)}
                        errorMessage={errors[index]}
                    />
                ))}
            </Tbody>
        </Table>
    );
};

RangeColorTable.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            range: PropTypes.shape({
                from: PropTypes.number.isRequired,
                to: PropTypes.number.isRequired,
            }).isRequired,
            color_code: PropTypes.string.isRequired,
        })
    ),
    setRows: PropTypes.func.isRequired,
};

RangeColorTable.defaultProps = {
    rows: [],
};

export default RangeColorTable;
